import { CARD_ANIMATIONS } from '@app/shared/constants/dailyCardResult';
import { CardAnimation, Advice } from '@app/shared/types/pages/dailyCardResult';
import { CardContent } from '@app/store/slices/content/contentTypes';

export const getCardAnimations = (imageSrc: string): CardAnimation[] =>
  CARD_ANIMATIONS.map((card, idx, arr) =>
    idx === arr.length - 1 ? { ...card, src: imageSrc || card.src } : card
  );

export const getAdvices = (cardContent: CardContent): Advice[] =>
  ([1, 2, 3] as const)
    .map((i) => {
      const title = cardContent[`name${i}`];
      const description = cardContent[`description${i}`];
      return title && description ? { title, description } : null;
    })
    .filter((advice): advice is Advice => advice !== null);
